import { QRCodeSVG } from "qrcode.react";

import { Card } from "@/components/ui/Card";
import { WHATSAPP_INVITE_URL } from "@/config/constants";

interface Props {
  qrSize?: number;
  showQr?: boolean;
}

export function WhatsAppCard({ qrSize = 120, showQr = true }: Props) {
  return (
    <Card>
      <div className="flex flex-col items-center gap-5 text-center sm:flex-row sm:items-stretch sm:gap-6 sm:text-left">
        {showQr ? (
          <div className="flex shrink-0 items-center justify-center">
            <div className="rounded-md border border-line bg-paper p-2">
              <QRCodeSVG
                value={WHATSAPP_INVITE_URL}
                size={qrSize}
                fgColor="#1B2E26"
                bgColor="#F7F3EA"
                level="M"
                aria-label="WhatsApp invite QR code"
              />
            </div>
          </div>
        ) : (
          <div
            aria-hidden
            className="grid h-20 w-20 shrink-0 place-items-center rounded-full bg-masjidGreen/10 text-masjidGreen"
          >
            <WhatsAppGlyph size={40} />
          </div>
        )}
        <div className="flex-1">
          <h3 className="font-serif text-lg text-ink">Join the Community Group</h3>
          <p className="mt-2 text-sm leading-relaxed text-muted">
            Get prayer-time changes, Janaza notices, and Jummah announcements directly
            on WhatsApp. Scan the code or tap below.
          </p>
          <a
            href={WHATSAPP_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center justify-center gap-2 rounded-md bg-masjidGreen px-5 py-2.5 text-sm font-medium text-paper transition-colors hover:bg-masjidGreen/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-masjidGreen"
          >
            <WhatsAppGlyph size={16} />
            Open in WhatsApp
          </a>
        </div>
      </div>
    </Card>
  );
}

function WhatsAppGlyph({ size }: { size: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden>
      <path d="M19.05 4.91A10 10 0 0 0 2.05 16l-1 5.04 5.16-1.02A10 10 0 1 0 19.05 4.91Zm-7 16.18a8 8 0 0 1-4.07-1.12l-.29-.17-3.06.61.62-2.98-.19-.31a8 8 0 1 1 6.99 3.97Zm4.39-5.84c-.24-.12-1.42-.7-1.64-.78-.22-.08-.39-.12-.55.12-.16.24-.63.78-.77.94-.14.16-.28.18-.52.06a6.55 6.55 0 0 1-3.27-2.86c-.25-.43.25-.4.7-1.33.08-.16.04-.3-.02-.42-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42l-.47-.01a.9.9 0 0 0-.65.3 2.74 2.74 0 0 0-.86 2.04c0 1.21.88 2.38 1 2.55.12.16 1.74 2.65 4.21 3.72.59.25 1.05.4 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28Z" />
    </svg>
  );
}
